import { render, staticRenderFns } from "./StandardsMapping.vue?vue&type=template&id=08616d85&"
import script from "./StandardsMapping.vue?vue&type=script&lang=ts&"
export * from "./StandardsMapping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports